<template>
  <div class="base-menu">
    <div class="base-menu__activator">
      <slot name="activator" :on="onEvent" :active="show"></slot>
    </div>

    <div
      ref="card"
      v-if="show"
      class="base-menu__card"
      :style="[menuCardStyle, cardStyle]"
      :class="[cardClass, { fixed, absolute: fixedOnPage }]"
      v-click-out="closeOnOutClick ? close : null"
      @click="onContentClick"
    >
      <slot name="default" :active="show"></slot>

      <button
        v-if="useCloseBtn"
        class="base-btn base-btn--x-small base-menu__close-btn"
        @click="close"
      >
        <BaseSvg name="ico-cross" width="0.9rem" height="0.9rem" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseMenu',
  props: {
    color: {
      type: String,
      default: 'white',
    },
    cardStyle: {
      type: Object,
      default: () => ({}),
    },
    cardClass: {
      type: [String, Array, Object],
      default: '',
    },
    closeOnContentClick: {
      type: Boolean,
      default: false,
    },
    closeOnOutClick: {
      type: Boolean,
      default: true,
    },
    useCloseBtn: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    fixedOnPage: {
      type: Boolean,
      default: false,
    },
    beforeClose: {
      type: Function,
      default: () => true,
    },
  },
  data() {
    return {
      show: false,
      clickEvent: {
        x: 0,
        y: 0,
      },
      cardSize: {},
    };
  },
  computed: {
    onEvent() {
      return {
        click: this.onClick,
      };
    },
    menuCardStyle() {
      return {
        backgroundColor: this.color,
        ...this.cardStyle,
      };
    },
  },
  watch: {
    show(show) {
      if (show) {
        this.$emit('open');

        if (this.fixed || this.fixedOnPage) {
          this.$nextTick(() => {
            document.body.appendChild(this.$refs.card);
            this.computeMenu();
          });
        }
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    if (this.fixed || this.fixedOnPage) this.$refs.card?.remove();
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onClick($event) {
      this.show = !this.show;

      if (this.show) {
        this.clickEvent = $event;
      }
    },
    onResize() {
      this.computeMenu();
    },
    computeMenu() {
      if (!this.show) return;

      if (this.fixed) {
        // TODO fixed development in progress
        this.computeAsFixed();
      }

      if (this.fixedOnPage) {
        this.computeAsFixedOnPage();
      }
    },
    computeAsFixed() {
      const card = this.$refs.card;
      const { x, y } = this.clickEvent;

      card.style.left = `${x}px`;
      card.style.top = `${y}px`;
    },
    computeAsFixedOnPage() {
      const card = this.$refs.card;
      const { width } = getComputedStyle(card);
      const { pageX, pageY } = this.clickEvent;

      let positionX = pageX;

      const diff = document.body.clientWidth - pageX;

      if ((diff - parseInt(width, 10)) < 20) {
        positionX = document.body.clientWidth - (parseInt(width, 10) + 10);
      }

      card.style.left = `${positionX}px`;
      card.style.top = `${pageY}px`;
    },
    onContentClick() {
      if (this.closeOnContentClick) this.close();
    },
    close() {
      if (!this.beforeClose()) return;
      this.show = false;
      this.$emit('close');

      if (this.fixed || this.fixedOnPage) {
        setTimeout(() => this.$refs.card?.remove());
      }
    },
  },
};
</script>
